define([
  "jquery",
  "colorbox"],
function($) {

  var colorboxConfirm = function(settings, okCallback, cancelCallback,closedCallback) {

    var _settings = settings || {};
    /*
    Example of settings
    {
      title: "Remove Item",
      msg: "Are you sure you would like to remove this item?",
      buttons: { ok: { text: "Yes"}, cancel: { text: "No" } }
      cssClass: "error"
    }
    Example of settings
    {
      html: "<div><span>Hello world</span></div>"
    }
    Example of settings
    {
      html: "<div><span>Click ok</span><button id='btn-ok'></button></div>",
      okElementId: "btn-ok",
    }
    Example of settings
    {
      html: "<div><span>Click ok</span><button id='btn-ok'></button><button id='btn-cancel'></button></div>",
      okElementId: "btn-ok",
      cancelElementId: "btn-cancel"
    }
    */

    var html = "";
    if (_settings.html) {
      html = _settings.html;
    } else {
      var cssClass = _settings.cssClass || "";
      var buttonSettings = _settings.buttons || {};
      var okId = "colorbox-ok";
      var okText = (buttonSettings.ok && buttonSettings.ok.text) || "Ok";
      var cancelId = "colorbox-cancel";
      var cancelText = ( buttonSettings.cancel && buttonSettings.cancel.text ) || "Cancel";

      // Blinds.com
      if (_settings.siteId === 3) {
        html = 
          "<div class='mw7'> " +
          "  <div id='cfirm' class='ma3 " + cssClass + "'>" +
          "    <h3 id='title' class='" + cssClass + "'>" + _settings.title + "</h3>" +
          "    <p id='msg' class='" + cssClass + "'>" + settings.msg + "</p>" +
          "    <div class='" + cssClass + "'>" +
          "      <button id='" + okId + "' class='gcc-btn gcc-btn-primary mr2-ns w-100 w-auto-ns mb2 mb0-ns " + cssClass + "'>" + okText + "</button>" +
          "      <button id='" + cancelId + "' class='gcc-btn gcc-btn-primary-outline w-100 w-auto-ns mb2 mb0-ns " + cssClass + "'>" + cancelText + "</button>" +
          "    </div>" +
          "  </div>" +
          "</div>";
      } else {
        html = "<div class='bdc-colorbox-confirm-modal'> " +
          "<div id='colorbox-confirm' class='bdc-colorbox-confirm " + cssClass + "'>" +
          "<h3 id='title' class='bdc-colorbox-confirm-title " + cssClass + "'>" + _settings.title + "</h3>" +
          "<p id='msg' class='bdc-colorbox-confirm-message " + cssClass + "'>" + settings.msg + "</p>" +
          "<div class='bdc-colorbox-confirm-buttons " + cssClass + "'>" +
          "<button id='" + okId + "' class='bdc-btn bdc-colorbox-confirm-ok " + cssClass + "'>" + okText + "</button>" +
          "<button id='" + cancelId + "' class='bdc-btn bdc-colorbox-confirm-cancel " + cssClass + "'>" + cancelText + "</button>" +
          "</div>" +
          "</div>" +
          "</div>";
      }
      _settings.okElementId = okId;
      _settings.cancelElementId = cancelId;
    }

    var registerCallbacks = function (okHandler, cancelHandler) {

      if (okHandler && okHandler.elementId) {
        var ok = document.getElementById(okHandler.elementId);
        if (ok) {
          ok.onclick = function () {
            okHandler.callback && okHandler.callback.call(this);
            $.colorbox.close();
          };
        }
      }

      if (cancelHandler && cancelHandler.elementId) {
        var cancel = document.getElementById(cancelHandler.elementId);
        if (cancel) {
          cancel.onclick = function () {
            cancelHandler.callback && cancelHandler.callback.call(this);
            $.colorbox.close();
          };
        }
      }
    }

    var okHandler = { elementId: _settings.okElementId, callback: okCallback };
    var cancelHandler = { elementId: _settings.cancelElementId, callback: cancelCallback };

    $.colorbox({
      html: html,
      transition: "none",
      maxWidth: "95%",
      maxHeight: "95%",
      onComplete: function () {
        $.colorbox.resize();
        registerCallbacks(okHandler, cancelHandler);
      },
      onClosed: function () {
        if (closedCallback && !!( closedCallback && closedCallback.constructor && closedCallback.call && closedCallback.apply )) {
          closedCallback();
        }
      }
    });

  };

  return colorboxConfirm;

});
